// ============================================
// COSMIC HINDU - Cart Page
// ============================================

import { Link } from 'react-router-dom';
import { useCart } from '@context/CartContext';
import { formatPrice } from '@utils/helpers';

export default function CartPage() {
  const { items, itemCount, subtotal, shipping, total, removeItem, updateQty } = useCart();

  if (items.length === 0) {
    return (
      <section className="py-20 text-center">
        <div className="text-5xl mb-4">🛒</div>
        <h2 className="text-2xl text-temple-cream mb-2">Your cart is empty</h2>
        <p className="text-white/40 mb-8">Explore our divine collection</p>
        <Link to="/shop" className="btn-primary no-underline">Browse Products</Link>
      </section>
    );
  }

  return (
    <section className="py-10">
      <div className="max-w-7xl mx-auto px-5">
        <h1 className="text-3xl font-bold text-temple-cream mb-8 font-display">Shopping Cart ({itemCount} items)</h1>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Cart Items */}
          <div className="lg:col-span-2 space-y-4">
            {items.map((item) => (
              <div key={item.id} className="card p-5 flex gap-5">
                <Link to={`/product/${item.id}`}>
                  <img src={item.images?.[0] || item.img} alt={item.name} className="w-24 h-24 rounded-md object-cover" />
                </Link>
                <div className="flex-1">
                  <Link to={`/product/${item.id}`} className="no-underline">
                    <h3 className="text-base font-semibold text-temple-cream hover:text-gold-500 transition-colors">{item.name}</h3>
                  </Link>
                  <div className="text-lg font-bold text-gold-500 font-display mt-1">{formatPrice(item.price)}</div>
                  <div className="flex items-center gap-4 mt-3">
                    <div className="flex items-center gap-3">
                      <button onClick={() => updateQty(item.id, item.qty - 1)}
                        className="w-8 h-8 rounded border border-gold-500/20 bg-transparent text-gold-500 cursor-pointer text-base">−</button>
                      <span className="text-temple-cream font-sans text-sm w-6 text-center">{item.qty}</span>
                      <button onClick={() => updateQty(item.id, item.qty + 1)}
                        className="w-8 h-8 rounded border border-gold-500/20 bg-transparent text-gold-500 cursor-pointer text-base">+</button>
                    </div>
                    <span className="text-white/40 text-sm">= {formatPrice(item.price * item.qty)}</span>
                    <button onClick={() => removeItem(item.id)}
                      className="ml-auto text-maroon-500 text-xs bg-transparent border-none cursor-pointer font-body hover:text-maroon-400">
                      Remove
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Summary */}
          <div className="card-admin p-6 h-fit sticky top-24">
            <h3 className="text-lg text-temple-cream font-semibold mb-5">Order Summary</h3>
            <div className="space-y-3 mb-5">
              <div className="flex justify-between text-sm text-white/50">
                <span>Subtotal</span><span className="text-white/70">{formatPrice(subtotal)}</span>
              </div>
              <div className="flex justify-between text-sm text-white/50">
                <span>Shipping</span><span className="text-emerald-400">{shipping === 0 ? 'FREE' : formatPrice(shipping)}</span>
              </div>
            </div>
            <div className="flex justify-between pt-4 border-t border-gold-500/10">
              <span className="text-lg font-bold text-temple-cream">Total</span>
              <span className="text-2xl font-bold text-gold-500 font-display">{formatPrice(total)}</span>
            </div>
            <Link to="/checkout" className="btn-primary w-full text-center no-underline mt-5 block">Proceed to Checkout</Link>
            <Link to="/shop" className="block text-center text-gold-500 text-sm mt-3 no-underline hover:underline">Continue Shopping</Link>
          </div>
        </div>
      </div>
    </section>
  );
}
